import { Component, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { Router, NavigationStart } from '@angular/router';
import { Idle, DocumentInterruptSource, AutoResume } from '@ng-idle/core';
import { AppConfig } from './app.config';
import { FoucsChangeService } from './services/focuschange.service';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html'
})
export class AppComponent implements OnInit {
    idleTime: number = AppConfig.config.idleTime;
    timeout: number = AppConfig.config.timeout;
    cpuiLogoutUrl: string = AppConfig.config.cpuiLogoutUrl;

    showInactivity: boolean;
    countdown: string;

    constructor(private titleService: Title
        , private idle: Idle
        , private router: Router
        , private foucsChangeService: FoucsChangeService) {

        // Track idle time
        this.trackBrowserIdleTime();

        router.events.subscribe(event => {
            if (event instanceof NavigationStart) {
                if (event.url == "/" || event.url.indexOf('/login') >= 0) {
                    this.idle.stop();
                }
                else {
                    this.idle.watch();
                }
            };
        });
    }

    ngOnInit() {
    }

    trackBrowserIdleTime() {
        // sets an idle timeout X seconds
        this.idle.setIdle(this.idleTime);

        // sets a timeout period of y seconds. after x + y seconds of inactivity, it considered timed out.
        this.idle.setTimeout(this.timeout);

        // sets the default interrupts, in this case, things like clicks, scrolls, touches to the document
        this.idle.setInterrupts([new DocumentInterruptSource('click keydown mousemove pointermove DOMMouseScroll mousewheel mousedown touchstart touchmove scroll')]);

        this.idle.setAutoResume(AutoResume.notIdle);

        this.idle.onTimeout.subscribe(() => {
            window.location.href = this.cpuiLogoutUrl;
        });

        this.idle.onTimeoutWarning.subscribe((c) => {
            this.showInactivity = true;
            this.countdown = '' + Math.floor(c / 60) + ':' + ((c % 60 < 10) ? ('0' + c % 60) : c % 60);
            this.foucsChangeService.changeFocus(false);
        });

        this.stayLoggedIn();
    }

    public setTitle(newTitle: string) {
        this.titleService.setTitle(newTitle);
    }

    stayLoggedIn() {
        this.idle.watch();
        this.showInactivity = false;
        this.foucsChangeService.changeFocus(true);
    }
}
